module.exports = __webpack_public_path__ + "static/media/PinkGoggles.4e27ec3d.jpeg";